import React, { useState } from 'react'
import Swal from 'sweetalert2'
import apiClient from '../../config/api'

const AddUnit = () => {
  const [formData, setFormData] = useState({
    name: '',
    abbreviation: ''
  })
  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      const payload = {
        name: formData.name.trim(),
        abbreviation: formData.abbreviation.trim() || null
      }

      await apiClient.post('/api/products/units/', payload)

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Unit created successfully!',
        confirmButtonText: 'OK'
      })

      // Reset form
      setFormData({
        name: '',
        abbreviation: ''
      })
    } catch (error) {
      console.error('Error creating unit:', error)
      const errorMessage = error.response?.data?.name?.[0] || 
                          error.response?.data?.abbreviation?.[0] ||
                          error.response?.data?.non_field_errors?.[0] ||
                          error.response?.data?.detail ||
                          error.response?.data?.message ||
                          'Failed to create unit. Please try again.'
      
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className="pagetitle">
        <h1>Add Unit</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item">Units</li>
            <li className="breadcrumb-item active">Add Unit</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                  <i className="bi bi-rulers me-2"></i>
                  Add New Unit
                </h5>

                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <label htmlFor="name" className="col-sm-2 col-form-label">Unit Name <span className="text-danger">*</span></label>
                    <div className="col-sm-10">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder="Enter unit name (e.g., Kilogram, Liter, Piece)"
                        disabled={loading}
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <label htmlFor="abbreviation" className="col-sm-2 col-form-label">Abbreviation</label>
                    <div className="col-sm-10">
                      <input
                        type="text"
                        className="form-control"
                        id="abbreviation"
                        name="abbreviation"
                        value={formData.abbreviation}
                        onChange={handleChange}
                        placeholder="Enter abbreviation (e.g., kg, L, pcs) - Optional"
                        disabled={loading}
                      />
                      <small className="form-text text-muted">Optional: Short form of the unit name</small>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-sm-10 offset-sm-2">
                      <button 
                        type="submit" 
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Creating...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-plus-circle me-2"></i>
                            Create Unit
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default AddUnit

